import SurfTooltip from './SurfTooltip';

export default SurfTooltip;
export type { SurfTooltipProps } from './SurfTooltip';
